"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _childrenButtons = _interopRequireDefault(require("@/views/userCenter/componens/childrenButtons.vue"));
var _index = _interopRequireDefault(require("@/components/filterColumn/index.vue"));
var _index2 = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _dangerousDeclaration = require("@/api/bookSpace/dangerousDeclaration");
var _index3 = _interopRequireDefault(require("@/components/SailScheduleOne/index.vue"));
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "dangerousDeclaration",
  components: {
    sailSchedule: _index3.default,
    Pagination: _index2.default,
    filterColumn: _index.default,
    ChildrenButtons: _childrenButtons.default
  },
  data: function data() {
    return {
      sailScheduleDialogVisible: false,
      listQuery: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      dataTotal: 0,
      tableDataMain: [],
      hotSettings: {
        dragCheck: true,
        height: '300',
        width: 'auto',
        stretchH: 'all',
        manualColumnResize: true,
        language: 'zh-CN',
        licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
        readOnly: true,
        columnSorting: true,
        showSelection: false,
        fixedColumnsLeft: 1,
        fragmentSelection: 'cell',
        copyPaste: false
      },
      dialogForm: {
        sysAccountId: '',
        accountNo: '',
        accountName: '',
        password: '',
        confirmPassword: ''
      },
      dialogFormRules: {
        accountNo: [{
          required: true,
          message: '请填写账号',
          trigger: 'blur'
        }],
        accountName: [{
          required: true,
          message: '请填写用户名',
          trigger: 'blur'
        }]
      },
      searchFormDanger: {
        blNo: ""
        // blNo: "SITDSHHKA70211",
      },
      searchFormDangerRules: {
        blNo: [{
          required: true,
          message: '',
          trigger: 'change'
        }]
      },
      searchFormDocument: {
        // vesselCode: '',
        // voyageNo: '',
        // voyageLeg: '',
        vesselCode: 'STNB',
        voyageNo: '2318',
        voyageLeg: 'S'
      },
      doucmentCutTimeData: '',
      nowDateTime: '',
      isDelayTime: false,
      dangerForm: {},
      dangerDialogVisible: false,
      fileList: [],
      rowBlNo: '',
      clickTableItem: ''
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      _this.resizeHotTable();
    });
    this.nowDateTime = this.getNowFormatTime();
  },
  methods: {
    openDialog: function openDialog() {
      if (this.tableDataMain.length < 1) {
        this.$message({
          message: this.$t('userCenter.dangerousDeclaration.noDataWarning'),
          type: 'warning'
        });
        return;
      }
      if (!this.doucmentCutTimeData) {
        this.$message({
          message: this.$t('userCenter.dangerousDeclaration.doucmentCutTimeDataWarning'),
          type: 'warning'
        });
        return;
      }
      if (this.isDelayTime) {
        this.$message({
          message: this.$t('userCenter.dangerousDeclaration.isDelayTimeWarning'),
          type: 'warning'
        });
        return;
      }
      if (!this.searchFormDocument.vesselCode || !this.searchFormDocument.voyageNo || !this.searchFormDocument.voyageLeg) {
        this.$message({
          message: this.$t('userCenter.dangerousDeclaration.vesselWarning'),
          type: 'warning'
        });
        return;
      }
      this.dangerDialogVisible = true;
    },
    tableRowClick: function tableRowClick(data) {
      console.log('data', data);
      this.clickTableItem = data.record;
    },
    closeDialog: function closeDialog() {
      this.fileList = [];
    },
    uploadFile: function uploadFile(item) {
      var _this2 = this;
      var formDatas = new FormData();
      this.loading = (0, _utils.load)();
      (0, _dangerousDeclaration.uploadAttach)(formDatas).then(function (res) {
        _this2.$message({
          message: _this2.$t('userCenter.dangerousDeclaration.uploadSuccess'),
          type: 'success'
        });
        _this2.searchFnDanger();
      }).finally(function () {
        // this.fileList = [];
        // this.$refs.upload.clearFiles();
        _this2.loading.close();
      });
      console.log('this.fileList', this.fileList);
    },
    getNowFormatTime: function getNowFormatTime() {
      var nowDate = new Date();
      var colon = ":";
      var h = nowDate.getHours();
      var m = nowDate.getMinutes();
      var s = nowDate.getSeconds();
      //补全0，并拼接
      return this.getNowFormatDay(nowDate) + " " + this.completeDate(h) + colon + this.completeDate(m);
    },
    getNowFormatDay: function getNowFormatDay(nowDate) {
      var char = "-";
      if (nowDate == null) {
        nowDate = new Date();
      }
      var day = nowDate.getDate();
      var month = nowDate.getMonth() + 1; //注意月份需要+1
      var year = nowDate.getFullYear();
      //补全0，并拼接
      return year + char + this.completeDate(month) + char + this.completeDate(day);
    },
    completeDate: function completeDate(value) {
      return value < 10 ? "0" + value : value;
    },
    selectionChangeSailSchedule: function selectionChangeSailSchedule(row) {
      this.sailScheduleDialogVisible = false;
      this.searchFormDocument.vesselCode = row.vesselCode;
      this.searchFormDocument.vesselName = row.vesselName;
      this.searchFormDocument.voyageLeg = row.voyageLeg;
      this.searchFormDocument.voyageNo = row.voyageNo;
    },
    searchFn: function searchFn(val) {
      this.listQuery.currentPage = val.page;
      this.listQuery.pageSize = val.limit;
      this.searchFnDanger();
    },
    handleOpenVessel: function handleOpenVessel() {
      this.sailScheduleDialogVisible = true;
    },
    resizeHotTable: function resizeHotTable() {
      this.$refs.hotTableCostMain.resizeTo();
    },
    searchFnDanger: function searchFnDanger() {
      var _this3 = this;
      if (this.searchFormDanger.blNo.length == 0) {
        this.$message({
          message: this.$t('userCenter.dangerousDeclaration.searchBlNoWarning'),
          type: 'warning'
        });
        return;
      }
      var data = this.searchFormDanger;
      data.pageStart = this.listQuery.currentPage;
      data.pageSize = this.listQuery.pageSize;
      this.loading = (0, _utils.load)();
      (0, _dangerousDeclaration.getDgCargoDeclareSearch)(data).then(function (res) {
        _this3.tableDataMain = res.data.records;
        _this3.listQuery.total = res.data.totalRecord;
      }).catch(function (err) {}).finally(function () {
        _this3.loading.close();
      });
    },
    changeVesselCode: function changeVesselCode(vesselCode, voyageNo, voyageLeg) {
      console.log('vesselCode,voyageNo,voyageLeg', vesselCode, voyageNo, voyageLeg);
    },
    changeVoyageNo: function changeVoyageNo(vesselCode, voyageNo, voyageLeg) {
      console.log('vesselCode,voyageNo,voyageLeg', vesselCode, voyageNo, voyageLeg);
    },
    changeVoyageLeg: function changeVoyageLeg(vesselCode, voyageNo, voyageLeg) {
      console.log('vesselCode,voyageNo,voyageLeg', vesselCode, voyageNo, voyageLeg);
    },
    resetForm: function resetForm() {
      this.searchFormDanger.blNo = '';
      this.searchFormDocument.vesselCode = '';
      this.searchFormDocument.voyageNo = '';
      this.searchFormDocument.voyageLeg = '';
    },
    searchFnDocument: function searchFnDocument() {
      var _this4 = this;
      if (!this.searchFormDocument.vesselCode || !this.searchFormDocument.voyageNo || !this.searchFormDocument.voyageLeg) {
        this.$message({
          message: this.$t('userCenter.dangerousDeclaration.searchFormDocumentWarning'),
          type: 'warning'
        });
        return;
      }
      var data = this.searchFormDocument;
      this.loading = (0, _utils.load)();
      (0, _dangerousDeclaration.getDoucmentCutTime)(data).then(function (res) {
        _this4.doucmentCutTimeData = res.data;
        if (_this4.doucmentCutTimeData < _this4.nowDateTime) {
          _this4.isDelayTime = true;
        } else {
          _this4.isDelayTime = false;
        }
      }).catch(function (err) {}).finally(function () {
        _this4.loading.close();
      });
    },
    handleLock: function handleLock(row) {},
    handleResetPassword: function handleResetPassword() {},
    loadDataByBLNo: function loadDataByBLNo() {
      var _this5 = this;
      if (this.searchFormDanger.blNo) {
        this.loading = (0, _utils.load)();
        (0, _dangerousDeclaration.loadBookingHeadByBLNo)(this.searchFormDanger.blNo).then(function (res) {
          if (res.success) {
            //this.searchForm.pol = res.data.pol;
            _this5.searchFormDocument.vesselCode = res.data ? res.data.vesselCode : '';
            _this5.searchFormDocument.voyageNo = res.data ? res.data.voyageNo : '';
            _this5.searchFormDocument.voyageLeg = res.data ? res.data.voyageLeg : '';
          }
          if (!_this5.searchFormDocument.vesselCode || !_this5.searchFormDocument.voyageNo || !_this5.searchFormDocument.voyageLeg) {
            _this5.doucmentCutTimeData = '';
            return;
          }
          var data = _this5.searchFormDocument;
          _this5.loading = (0, _utils.load)();
          (0, _dangerousDeclaration.getDoucmentCutTime)(data).then(function (res) {
            _this5.doucmentCutTimeData = res.data;
            if (_this5.doucmentCutTimeData < _this5.nowDateTime) {
              _this5.isDelayTime = true;
            } else {
              _this5.isDelayTime = false;
            }
          }).catch(function (err) {}).finally(function () {
            _this5.loading.close();
          });
        }).finally(function () {
          _this5.loading.close();
        });
      }
    },
    blNoChange: function blNoChange() {
      this.searchFormDanger.blNo = this.searchFormDanger.blNo.trim();
    }
  }
};